import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';

import { isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import {
  ErrorScreen,
  VFButton,
  VFScreen,
  VFText,
} from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { SelectionList } from '../../../../Common/UI';
import { AddOnsUsersLoading } from '../../Components';

import styles from './AddOnsUsers.style';

const DEFAULT_NUMBER_OF_SHOWN_USERS = 5;

class AddOnsUsers extends Component {
  constructor(props) {
    super(props);
    this.selectedUsersInsideAddon = [...props.users];
    this.unselectedUsersInsideAddon = [];
    this.selectedUsersOutsideAddon = [];
    this.unselectedUsersOutsideAddon = [...props.unassignedUsers];
    this.state = {
      isInsideListChanged: false,
      isOutsideListChanged: false,
    };
  }
  componentDidUpdate = prevProps => {
    const { unassignedUsers } = this.props;
    if (prevProps.unassignedUsers.length !== unassignedUsers.length) {
      this.unselectedUsersOutsideAddon = [...this.props.unassignedUsers];
    }
  };

  getVFScreenProps = () => {
    const { onBack, vfScreenProps } = this.props;
    return {
      showClose: false,
      title: 'soho_user_edit_add_ons_title',
      showBack: true,
      onBack: onBack,
      withSubHeader: true,
      withHeaderSpace: true,
      renderSubHeaderTitle: this.renderSubHeaderTitle,
      ...vfScreenProps,
    };
  };
  getNewAssignedAndUnAssignedUsers = () => {
    return {
      newAssignedUsers: [...this.selectedUsersInsideAddon, ...this.selectedUsersOutsideAddon],
      newUnAssignedUsers: [...this.unselectedUsersInsideAddon, ...this.unselectedUsersOutsideAddon],
    };
  };
  get assignedUsersSelectionListProps() {
    const { images, users } = this.props;
    return {
      title: 'soho_user_edit_add_ons_assigned_users_title',
      dataConfig: {
        data: users,
        dataTitleKey: 'name',
        dataSubTitleKey: 'phoneNumber',
        defaultNumberOfShownData: DEFAULT_NUMBER_OF_SHOWN_USERS,
      },
      images: images,
      withSelect: true,
      withShowMore: true,
      selectAllButtonTitle: 'soho_user_edit_add_ons_select_all_button_title',
      showMoreButtonTitle: 'soho_user_edit_add_ons_show_more_title',
      showLessButtonTitle: 'soho_user_edit_add_ons_show_less_title',
      onSelectPress: this.checkListChangesInsideAddon,
      emptyText: 'soho_user_edit_add_ons_empty_assigned_users',
      defaultSelectedDataState: users,
    };
  }

  get unassignedUsersSelectionListProps() {
    const { images, unassignedUsers } = this.props;

    return {
      title: 'soho_user_edit_add_ons_unassigned_users_title',
      dataConfig: {
        data: unassignedUsers,
        dataTitleKey: 'name',
        dataSubTitleKey: 'phoneNumber',
        defaultNumberOfShownData: DEFAULT_NUMBER_OF_SHOWN_USERS,
      },
      images: images,
      withSelect: true,
      withShowMore: true,
      selectAllButtonTitle: 'soho_user_edit_add_ons_select_all_button_title',
      primaryButtonTitle: 'soho_user_edit_add_ons_confirm_button_title',
      showMoreButtonTitle: 'soho_user_edit_add_ons_show_more_title',
      showLessButtonTitle: 'soho_user_edit_add_ons_show_less_title',
      renderButtonsSection: this.renderButton,
      onSelectPress: this.checkListChangesOutsideAddon,
      emptyText: 'soho_user_edit_add_ons_empty_unassigned_users',
    };
  }

  checkListChangesInsideAddon = (selectedUsers, unselectedUsers) => {
    this.selectedUsersInsideAddon = selectedUsers;
    this.unselectedUsersInsideAddon = unselectedUsers;

    this.setState({ isInsideListChanged: unselectedUsers.length !== 0 });
  };
  checkListChangesOutsideAddon = (selectedUsers, unselectedUsers) => {
    this.selectedUsersOutsideAddon = selectedUsers;
    this.unselectedUsersOutsideAddon = unselectedUsers;

    this.setState({ isOutsideListChanged: selectedUsers.length !== 0 });
  };

  renderUsersLists = () => {
    const { theme } = this.props;

    return (
      <View style={styles.containerStyle(theme)}>
        <SelectionList {...this.assignedUsersSelectionListProps} />
        <SelectionList {...this.unassignedUsersSelectionListProps} />
      </View>
    );
  };
  renderUsersScreen = () => {
    return (
      <>
        {this.renderHeader()}
        {this.renderUsersLists()}
      </>
    );
  };

  renderHeader = () => {
    return (
      <VFText
        i18nKey="soho_user_edit_add_ons_list_header"
        type="primary"
        style={styles.titleStyle}
      />
    );
  };
  renderButton = () => {
    const { onPrimaryButtonPress } = this.props;
    const { isInsideListChanged, isOutsideListChanged } = this.state;
    return (
      <VFButton
        title="soho_plans_add_user_confirm_button_title"
        type="primary"
        disabled={!(isInsideListChanged || isOutsideListChanged)}
        style={styles.confirmButtonStyle}
        onPress={() => {
          onPrimaryButtonPress(this.getNewAssignedAndUnAssignedUsers());
        }}
      />
    );
  };

  renderSubHeaderTitle = () => {
    const {
      name,
      price: { value, currency, unitOfMeasure },
      id,
      isCurrencyFirst,
    } = this.props;
    const priceAndCurrency = isCurrencyFirst ? `${currency}${value}` : `${value}${currency}`;
    return (
      <View style={styles.subHeaderTitle}>
        <VFText style={styles.headerTitleStyle} i18nKey={name} />
        <View style={styles.unitAmountContainer}>
          <VFText style={styles.amountStyle} i18nKey={priceAndCurrency} />
          <VFText style={styles.unitStyle} i18nKey={unitOfMeasure} />
        </View>

        <VFText
          style={styles.productIdStyle}
          placeHolders={[id]}
          i18nKey="soho_user_edit_add_ons_product_id"
        />
      </View>
    );
  };

  renderContent = () => {
    const { error, isLoading } = this.props;
    if (!_isNil(error)) {
      return this.renderError();
    } else if (isLoading) {
      return this.renderAddOnsUsersLoading();
    }
    return this.renderUsersScreen();
  };

  renderError = () => {
    const { error, onTryAgainPress } = this.props;
    return (
      <>
        {this.renderHeader()}
        <ErrorScreen
          iconStyle={styles.errorIconStyle}
          text={error?.message}
          {...error}
          onPress={onTryAgainPress}
          textButton={'soho_plans_failure_try_again'}
        />
      </>
    );
  };

  renderAddOnsUsersLoading = () => {
    const { users } = this.props;
    return <AddOnsUsersLoading usersCount={users.length} />;
  };

  render() {
    const { withTray, isLoading, error } = this.props;
    return (
      <VFScreen {...this.getVFScreenProps()}>
        <ScrollView
          scrollEnabled={!isLoading && _isNil(error)}
          contentContainerStyle={styles.scrollViewContentStyle(withTray)}
        >
          {this.renderContent()}
        </ScrollView>
      </VFScreen>
    );
  }
}

AddOnsUsers.defaultProps = {
  isCurrencyFirst: false,
  theme: LightThemeColors,
};

AddOnsUsers.propTypes = {
  vfScreenProps: PropTypes.object,
  withTray: PropTypes.bool.isRequired,
  isCurrencyFirst: PropTypes.bool,
  onPrimaryButtonPress: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  unassignedUsers: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    currency: PropTypes.string.isRequired,
    unitOfMeasure: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  onTryAgainPress: PropTypes.func,
  isLoading: PropTypes.bool,
  images: PropTypes.object,
};
export { AddOnsUsers };
export default withTheme(AddOnsUsers);
